import { useWindowSize } from "vue-window-size";
import usePub from "~/store/Public";
import useUser from "~/store/UserInfo";
import _ from "lodash";
import dayjs from "dayjs";

export default defineComponent({
	props: {
		hide: {
			type: Boolean,
			default: false,
		},
	},
	async setup(props, emits) {
		const { $bootstrap } = useNuxtApp();
		let bsOffcanvas: any;
		const { width, height } = useWindowSize();
		const messageInfo = ref({
			show: false,
			title: "",
			content: "",
		});
		const data = ref({
			window: [width, height],
			date: "",
			o: false,
			message: {
				count: 0,
				list: <Array<any>>[],
				updatetime: "",
			},
			buttonGroup: _.map(usePub().sideListGroup, (item) => {
				item.show = false;
				return item;
			}),
			allshow: false,
			selectFunc: "",
		});

		const selectFunc = computed({
			get() {
				return usePub().selectFunc;
			},
			set(data) {
				usePub().selectFunc = data;
			},
		});
		const quitsearch = ref("");
		const replaceSelName = (Route: any) => {
			return ((Route.params && Route.params.method ? Route.name?.toString().replace(/-method/g, "-" + Route.params.method.toString()) : Route.name) || "").toString();
		};
		const selectMenu = computed(() => {
			return (item: any) => {
				return item.select.indexOf(selectFunc.value) > -1;
			};
		});
		const PlistGroup = computed({
			get() {
				return usePub().sideListGroup;
			},
			set() {},
		});
		watch(
			() => {
				return PlistGroup.value;
			},
			(nval, oval) => {
				data.value.buttonGroup = _.map(PlistGroup.value, (items, keys) => {
					let show = _.reduce(
						PmenuBtn.value[items.values],
						(cur, item) => {
							return cur || selectMenu.value(item);
						},
						false,
					);
					items.show = show;
					return items;
				});
			},
		);
		onMounted(() => {
			selectFunc.value = replaceSelName(useRoute());
			// data.value.buttonGroup = _.map(PlistGroup.value, (items, keys) => {
			//     let show = _.reduce(PmenuBtn.value[items.values], (cur, item) => {
			//         return cur || selectMenu.value(item)
			//     }, false)
			//     items.show = show;
			//     return items;
			// });
			data.value.selectFunc = selectFunc.value;
		});

		const PmenuBtn = computed(() => {
			const res = _.groupBy(
				_.orderBy(
					_.map(
						_.filter(usePub().sideList, (item: any, keys) => {
							let check = item.companyOverview;
							if (check && quitsearch.value) {
								check = check && item.companyOver.name.toString().includes(quitsearch.value);
							}
							return check;
						}),
						(item: any, keys) => {
							return {
								name: item.companyOver.name,
								index: item.companyOver.index,
								group: item.group,
								icon: item.companyOver.icon,
								lock: item.companyOver.lock,
								url: item.url,
								select: item.select,
							};
						},
					),
					["index"],
					["asc"],
				),
				"group",
			);

			return res;
		});
		const LoginInfo = computed({
			get() {
				return useUser().LoginInfo;
			},
			set() {},
		});
		const UserInfo = computed({
			get() {
				return useUser().Info;
			},
			set() {},
		});
		const PointInfo = computed({
			get() {
				return useUser().Point;
			},
			set() {},
		});
		const sideList = computed({
			get() {
				return usePub().sideList;
			},
			set() {},
		});
		const PbuttonGroup = computed(() => {
			let list = data.value.buttonGroup;
			if (quitsearch.value) {
				list = _.filter(data.value.buttonGroup, (item, keys) => {
					let res = true;
					const check = (PmenuBtn.value[item.values]?.length ?? 0) > 0;
					// strContains
					return check;
				});
			}

			return list;
		});

		const PMessage = computed({
			get() {
				return usePub().messageshow;
			},
			set(data) {
				usePub().messageshow = data;
			},
		});
		const PMessageList = computed({
			get() {
				return data.value.message.list;
			},
		});
		const ckUrl = async (item: any) => {
			bsOffcanvas.hide();
			if (item.url == "logout") {
				await useUser().Logout();
				useRouter().replace({
					name: "login",
				});
				return;
			}
			if (item.url) {
				useRouter().push({
					name: item.url,
				});
			}
		};
		const toggleNavbar = () => {
			// if (!bsOffcanvas && LoginInfo.value.status && document.querySelector("#offcanvasNavbar")) {
			bsOffcanvas = new $bootstrap.Offcanvas("#offcanvasNavbar");
			// }else{

			// }
			bsOffcanvas.toggle();
		};
		const toggleNotify = (e) => {
			PMessage.value = !PMessage.value;
			data.value.o = true;
			e.preventDefault();
		};
		const openwindow = () => {
			// console.log(useRoute())
			const routeData = useRouter().resolve(useRoute());
			// 主頁面開啟新視窗並傳送資料
			// const newWin = window.open(routeData.href, "_blank");

			// 待新頁面載入完成後傳送資料
			// setTimeout(() => {
			// 	newWin.postMessage({ type: "INIT_DATA", payload: true }, "*");
			// }, 500);
			//  const routeData = useRouter().resolve(useRoute());
			preloadRouteComponents(routeData.href);
			const newWindow = window.open(routeData.href, "_blank",'noopener,noreferrer');
			if (newWindow) {
			    // const routeData = useRouter().resolve(useRoute());
				// 將新視窗導向 Nuxt 的路由
				// newWindow.location.href = routeData.href;
			}
			// window.open(routeData.href, "_blank");
		};
		const companyInfo = computed({
			get() {
				return usePub().companyInfo;
			},
			set() {},
		});
		const hiddenProperty: string | null = "hidden" in document ? "hidden" : "webkitHidden" in document ? "webkitHidden" : "mozHidden" in document ? "mozHidden" : null;
		const showNotification = (title: string, content: string, info: any) => {
			// 確保已經取得權限
			if (Notification.permission === "granted") {
				var notification = new Notification(title, {
					body: content,
					icon: companyInfo.value?.smallIcon || "", // 通知圖標，可選
					dir: "auto", // 文字方向，可選
				});

				// 當使用者點擊通知時觸發的事件
				notification.onclick = function () {
					console.log("通知被點擊了");
					openSource(info);
					window.focus(); // 將網頁視窗帶到最前面
				};
			} else {
				console.log("沒有權限發送通知");
			}
		};
		let firstNotice = false;
		if (hiddenProperty && props.hide) {
			let MessageSetTimeout: any = null;
			const loopMessage = async () => {
				if (!LoginInfo.value.status) {
					return;
				}
				const result = await usePub().getNoticeMessage(0, 5, {
					orwhere: {
						between: {
							createtime: { start: data.value.message.updatetime },
							updatatime: { start: data.value.message.updatetime },
						},
					},
				});
				data.value.message.updatetime = dayjs().format("YYYY-MM-DD HH:mm:ss");
				data.value.message.count = result.result.NoReadCount;
				if (result.result.data.length > 0) {
					if (data.value.message.list.length > 0) {
						const keyByList = _.keyBy(_.cloneDeep(data.value.message.list), "uid");
						const keyByRes = _.keyBy(result.result.data, "uid");
						const tmp = _.map(_.cloneDeep(data.value.message.list), (item, keys) => {
							if (keyByRes[item.uid]) {
								item = keyByRes[item.uid];
							}
							return item;
						});
						_.each(result.result.data, (item, keys) => {
							if (!keyByList[item.uid]) {
								tmp.push(item);
							}
						});

						const d = _.orderBy(tmp, ["createtime"], ["desc"]).splice(0, 5);

						data.value.message.list = d;
					} else {
						data.value.message.list = result.result.data;
					}
					if (firstNotice) {
						_.each(result.result.data, (item, keys) => {
							showNotification(item.title, item.content, item);
						});
					}
				}
				firstNotice = true;
				MessageSetTimeout = setTimeout(() => {
					loopMessage();
				}, 100000);
			};

			const visibilityChangeEvent = hiddenProperty.replace(/hidden/i, "visibilitychange");
			const onVisibilityChange = () => {
				if (!document[hiddenProperty]) {
					loopMessage();
				} else {
					clearTimeout(MessageSetTimeout);
				}
			};
			document.addEventListener(visibilityChangeEvent, onVisibilityChange);
			onVisibilityChange();
			window.addEventListener("click", (e) => {
				if (!data.value.o) {
					PMessage.value = false;
				}
				data.value.o = false;
			});
			watch(
				() => {
					return LoginInfo.value.status;
				},
				(nval, oval) => {
					if (nval) {
						onVisibilityChange();
					}
				},
			);
		}
		const selectSideMenu = async (item: any) => {
			selectFunc.value = item.url;
			bsOffcanvas.hide();
			if (item.url == "logout") {
				await useUser().Logout();
				useRouter().replace({
					name: "login",
				});
				return;
			}
			if (item.url) {
				useRouter().push({
					name: item.url,
				});
			}
			data.value.selectFunc = selectFunc.value;
		};
		const closeSider = () => {
			bsOffcanvas.hide();
		};
		const openSource = async (item: any) => {
			await usePub().readReadNotice(item.uid);
			if (item.source.uid.length == 1) {
				const page = <{ [keys: string]: any }>{
					TravelOrder: {
						name: "manage-groupSetting-order-orderuid",
						params: {
							orderuid: _.first(item.source.uid),
						},
					},
					member: {
						name: "manage-companyMember",
						query: {
							seluid: _.first(item.source.uid),
						},
					},
				};
				let redata: { [key: string]: any } = page[item.source.table];

				redata.query = redata.query || {};

				redata.query.sliderhide = 0;
				redata.query.headerHide = 0;
				const routeData = useRouter().resolve(redata);
				window.open(routeData.href, "_blank");
				// return redata;
			} else {
				messageInfo.value.show = true;
				messageInfo.value.title = item.title;
				messageInfo.value.content = item.content;
			}
			item.read = 1;
		};
		const alltoggle = () => {
			data.value.buttonGroup = _.map(data.value.buttonGroup, (item, keys) => {
				item.show = data.value.allshow;
				return item;
			});
		};
		const golink = () => {
			const token = localStorage.getItem("auth") || "";
			const T = token.replace(/\//g, "&2FO").replace(/\\/g, "&2Z7");
			window.location.href = UserInfo.value.url.index + `/auth/company/${T}`;
		};
		watch(
			() => {
				return data.value.allshow;
			},
			(val) => {
				alltoggle();
			},
		);

		return {
			data,
			LoginInfo,
			UserInfo,
			PointInfo,
			sideList,
			ckUrl,
			toggleNavbar,
			toggleNotify,
			openwindow,
			openSource,
			PMessage,
			selectSideMenu,
			selectMenu,
			PmenuBtn,
			quitsearch,
			PbuttonGroup,
			closeSider,
			golink,
			PMessageList,
			messageInfo,
			PlistGroup,
		};
	},
});
